webpackJsonp([179408692629387],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 5: Postprocess stereotypical autocompleted expressions '
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '100', max: '100' },
	          '100 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Another way to mitigate algorithmic bias is to remove bias from the predictions. For example, we can prepare two dictionaries of stereotypical words, one for men, and one for women. Gender swapping can be done in a random manner. One example is to replace a stereotypically perceived feminine word (e.g., "nurse") with a stereotypically perceived masculine word (e.g., "doctor").'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* In this case, we swap genders in the original dataset (see below). Any differences noted?'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://drive.google.com/file/d/1gQJNQb9zMIqrK2-mWQJTAbPe7nGMWc-q/view?usp=sharing', title: 'Dataset', target: '_blank' },
	            'Dataset'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Now run Google Colab below again to see the newly predicted next word given the prompt of either "man" or "woman". After you go to Google Colab, select "Runtime->Run all". Under the section "Gender Swapping", type either "man" or "woman" as the prompt and observe the next word. Repeat the process 10 times, 5 times with the prompt "man", and 5 times with "woman". Any differences noted?'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://colab.research.google.com/drive/1eO5UQ0YHOt5oIFP6PyZzwb6fsrdhUcxL?usp=sharing', title: 'Colab', target: '_blank' },
	            'Colab'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/4-clean/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-5-unawareness-js-da01cc52768ac9d6c207.js